var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00956 11.3431L17.1031 0.198264C17.2257 0.0750099 17.3703 0.00916157 17.5366 0.000719493C17.703 -0.00772258 17.8555 0.0581258 17.9941 0.198264C18.1328 0.338403 18.2025 0.489093 18.2033 0.650337C18.2042 0.811581 18.1349 0.96185 17.9954 1.10114L6.72291 12.4346C6.51874 12.6398 6.28095 12.7423 6.00956 12.7423C5.73817 12.7423 5.50038 12.6398 5.29621 12.4346L0.191838 7.30607C0.0691653 7.18281 0.00530825 7.03634 0.000266895 6.86666C-0.00477446 6.69697 0.0616034 6.54248 0.1994 6.40319C0.337197 6.26389 0.487178 6.19425 0.649341 6.19425C0.811505 6.19425 0.961485 6.26389 1.09928 6.40319L6.00956 11.3431Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.296dafc19a3b4db67743a5f93acf78ab.svg";
export { ForwardRef as ReactComponent };